import { defineXray } from "../src/xray/manifest.js";
import { SHELL_TOOL_NAMES } from "../src/mine/shell.js";
import { extractDepsOps, describeMissing } from "../extractors/deps/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/deps/spec.js";

export default defineXray({
  id: "deps",
  label: "Deps",
  title: "Dependencies agents added, bumped or interrogated — with the version a tool reported, and "
    + "which packages someone was asking about because they did not choose them",

  consumer: "someone reviewing what entered a dependency tree through an agent",
  decision: "which packages an agent introduced at what version, and which it was investigating because a build or licence forced it to",

  // A package coordinate in a public registry: identical for every tenant.
  // MEASURED AS FORMATTING. a package manager command reads as itself, and this corpus shows dependency work confined to single sessions
  tab: false,
  tabReason: "a package manager command reads as itself, and this corpus shows dependency work confined to single sessions",
  // Trace-only, so this does not down-select a tab of its own — it is how the
  // LINEAGE window finds the prompts carrying this lens's work. Same matcher
  // its tab-bearing siblings use: every op here is read off a shell command.
  substrate: { label: "shell (dependency changes)", match: (n) => SHELL_TOOL_NAMES.test(String(n).split("__").pop()) },

  feed: { domain: "deps" },
  extract: extractDepsOps, collect, group: build, groupBy, anchor, ignore,
  // A package coordinate in a public registry. Qualified by ecosystem, because the
  // bare package name is a common word and the graph refuses to cite one.
  lineage: {
    kind: "dependency",
    // Both halves checked, not `packages.length` — an array holding one empty
    // entry has a length and would interpolate into a ref of "<eco>/null", which
    // reads as a real coordinate.
    ref: (op) => (op.ecosystem && op.packages?.[0] ? `${op.ecosystem}/${op.packages[0]}` : null),
    // Interrogating a tree changes nothing; add / remove / bump all do.
    role: (op) => (op.kind === "inspect" ? "consultation" : "production"),
    text: (op) => op.output || "",
    label: (op) => `${op.kind} ${op.packages?.[0] || "an unnamed package"}`,
    intent: (op) => op.question || null,
  },

  emptyNote: "No dependency work in this window",
  explainMissing: describeMissing,
});
